/* Muyu lightweight performance helpers: image skeletons + font-ready state. */
(function() {
  var root = document.documentElement;

  function markReady() {
    root.classList.remove('site-loading');
    root.classList.add('site-ready');
  }

  function markFontsReady() {
    root.classList.add('fonts-ready');
  }

  function trackImages() {
    var selector = [
      '.pl__visual-img',
      '.pb__visual-img',
      '.psp__visual-img',
      '.trial__img',
      '.product-compare__img',
      '.gift-modal__hero-img',
      '.model-card__img',
      '.product-card__img',
      '.rv-scroll img',
      '.mv-review-card img'
    ].join(',');
    var images = Array.prototype.slice.call(document.querySelectorAll(selector));

    images.forEach(function(img) {
      if (!img || img.classList.contains('is-loaded')) return;
      img.classList.add('is-loading');

      var done = function() {
        img.classList.remove('is-loading');
        img.classList.add('is-loaded');
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
      };

      if (img.complete && img.naturalWidth !== 0) {
        done();
      } else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(markFontsReady).catch(markFontsReady);
  } else {
    markFontsReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackImages();
      markReady();
    }, { once: true });
  } else {
    trackImages();
    markReady();
  }

  window.addEventListener('load', function() {
    trackImages();
    markReady();
  }, { once: true });
})();
